var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invite-header"},[_c('img',{staticClass:"invite-header__back",attrs:{"src":require("@/assets/home/icn_arrow_left.png")},on:{"click":function($event){return _vm.$emit('back-click')}}}),_vm._v(" "),_c('span',{staticClass:"invite-header__title typo-heading-xl-bold"},[_vm._v("초대하기")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f065625","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new/molecules/InviteHeader.vue
// module id = null
// module chunks = 